import React from "react";
import { Link } from "react-router-dom";

export default function Home() {
  return (
    <>
      <section className="container" style={{ paddingTop: 48, paddingBottom: 16 }}>
        <p className="byline">Soft Tech Talks</p>
        <h1 className="headline" style={{ marginTop: 12 }}>
          Tiny libraries. Real results.
        </h1>
        <p className="subhead">
          Open-source Python tools that strip away setup friction so you can focus on the
          thinking — not the boilerplate.
        </p>
        <div style={{ marginTop: 28 }}>
          <Link to="/library" className="stt-btn stt-btn-primary">
            Browse Libraries
          </Link>
        </div>
      </section>

      <section className="container" style={{ paddingTop: 32, paddingBottom: 48 }}>
        <blockquote className="pullquote">
          "Math first → implementation next. Go from idea to demo in minutes."
        </blockquote>
      </section>
    </>
  );
}
